module.exports = __webpack_public_path__ + "img/icon_arrow_down_black.2e8e38cd.png";